import React from 'react';
import Tabela from './tabela';

const ProcessoFilho = ({ model, itemIdIgnorar, allowNew = true }) => {
  return (
    <div>
      <Tabela
        itemIdIgnorar={itemIdIgnorar}
        model={model.getModel('processosAssociados')}
        allowNew={allowNew}
      />
    </div>
  );
};

export default ProcessoFilho;